import { T }           from 'defa-object';
import ActiveContainer from 'scripts/poppet/active-container';
import template        from 'templates/subscriptionSettingsPanel.jst.html';

/**
 * defa.views.SubscriptionSettingsPanel
 * The Admin Panel for Subscriptions
 * @version 1.2.0
 */

const channelUser = Bb.Radio.channel( 'user' ),
	channel     = Bb.Radio.channel( 'objects' );

const selectors = {
	terminate: '[data-click=settings-terminate]',
	transfer : '[data-click=settings-transfer]',
	renew    : '[data-click=settings-renew]',
	replace  : '[data-click=settings-replace]',
};

const SubscriptionSettingsPanel = ActiveContainer.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template      : template,
	className     : 'card subscription-panel',
	submitReaction: 'close',
	
	ui: {
		terminate: selectors.terminate,
		transfer : selectors.transfer,
		renew    : selectors.renew,
		replace  : selectors.replace,
	},
	
	modelEvents: {
		'sync': 'render',
	},
	
	events: {
		'click @ui.terminate': 'onClickTerminate',
		'click @ui.transfer' : 'onClickTransfer',
		'click @ui.renew'    : 'onClickRenew',
		'click @ui.replace'  : 'onClickReplace',
	},
	
	templateContext: function () {
		return {
			unitType     : this.model.getUnitType(),
			isInstaller  : this.isInstaller(),
			customerName : this.getCustomerName(),
			validFromDate: this.getValidFromDate(),
			renewalDate  : this.getRenewalDate(),
		};
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when the user clicks the terminate button.
	 * @void
	 */
	onClickTerminate: function () {
		this.trigger( 'nav', 'subscription:terminate', [ this.model.get( 'id' ), ] );
	},
	
	/**
	 * Triggers when the user clicks the terminate button.
	 * @void
	 */
	onClickTransfer: function () {
		this.trigger( 'nav', 'subscription:transfer', [ this.model.get( 'id' ), ] );
	},
	
	/**
	 * Triggers when the user clicks the renew button.
	 * @void
	 */
	onClickRenew: function () {
		this.busy();
		this.model.enable();
	},
	
	/**
	 * Triggers when the user clicks the replace button.
	 * @void
	 */
	onClickReplace: function () {
		this.trigger( 'nav', 'subscription:replace', [ this.model.get( 'id' ), ] );
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Checks if the current user is a correct type of installer.
	 * @return {bool} True if the current user is an installer, false if not.
	 */
	isInstaller: function () {
		let family = channel.request( 'units' ).get( this.model.get( 'unit' ) ).get( 'family' ),
			role   = 'INSTALLER_%s'.replace( '%s', family.toUpperCase() );
		
		return channelUser.request( 'model' ).hasRoles( [ role, ] );
	},
	
	/**
	 * Get the customer's name.
	 * @return {string}  The combined name of the customer.
	 */
	getCustomerName: function () {
		return channel.request( 'customers' ).get( this.model.get( 'owner' ) ).name();
	},
	
	/**
	 * Gets the date-formatted validfrom date.
	 * @return {string} Translated human readable date formatted version of the validFrom date.
	 */
	getValidFromDate: function () {
		let date = new Date( this.model.get( 'validFrom' ) );
		return date.format( T.dateFormatShort );
	},
	
	/**
	 * Gets the date-formatted renewal date.
	 * @return {string} Translated human readable date formatted version of the validFrom date.
	 */
	getRenewalDate: function () {
		let date = new Date( this.model.get( 'transientExpirationDate' ) );
		return date.format( T.dateFormatShort );
	},
	
} );

export default SubscriptionSettingsPanel;